import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import moment from 'moment';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'ShipmentSummary',
  components: {
    VueElementLoading,
    Paginate
  },
  mixins:[PageTracker],
  data: function() {
    return {
      tripResultData: [],
      localuserid: [],
      localusermailid: [],
      localhubdetails: [],
      hubname: [],
      userRoles: [],
      shipmentNo: '',
      isLoading: false,
      lastRunsheet: [],
      lastSummary: [],
      shipmentupdateData: [],
      transactions: [],
      showTables: false,
      isSubmitLoading: false,
      allocation:[],
      ofd:[],
      pod:[],
      showmodal : false,
      userDataKey : '',
      isPrexo: false
    }
  },
  created: function() {
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.hubname = this.localhubdetails;
    this.userRoles = userdetail.userrole[0];

    if (this.$route.params.shipmentNo != ''){
      this.shipmentNo = this.$route.params.shipmentNo;
      this.onSubmit();
    }

  },
  filters: {
    changeDateFormat: function(date) {
      if (date != null || date != '') {
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
      }
    }
  },
  methods: {
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.isSubmitLoading = true;
          this.isLoading = true;
          this.showTables = false;
          this.isPrexo = false;
          let reqPayload = {
            shippingID: this.shipmentNo.trim()
          }
          //console.log('reqPayload',reqPayload);
          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'websupport/get/shipment/summary',
            'data': reqPayload
          })
          .then(result => {
            if( result.data.code === 200 ) {
              this.lastRunsheet = result.data.lmFinalData.srRunsheet;
              this.lastSummary = result.data.lmFinalData.lastMile;
              this.shipmentupdateData = result.data.ShipmentUpdateData;
              this.transactions = result.data.ShipmentUpdateData.Transactions;
              this.allocation = result.data.Prediction.alloction;
              this.ofd = result.data.Prediction.ofd;
              this.pod = result.data.Prediction.pod;
              this.isPrexo = this.lastSummary[0] && 'PrexoId' in this.lastSummary[0] ? true : false
              //this.$alertify.success('Record found.!');
            } else {
              this.$alertify.error(result.data.message);
            }
            this.isSubmitLoading = false;
            this.isLoading = false;
            this.showTables = true;
          }, error => {
            this.isLoading = false;
            this.isSubmitLoading = false;
          })
        }
      }).catch(() => {
        this.isLoading = false;
        this.isSubmitLoading = false;
        //console.log('errors exist', this.errors)
      });
    },
    resetForm() {
      this.isLoading = false;
      this.showTables = false;
      this.isSubmitLoading = false;
      this.shipmentNo = '';
      this.errors.clear();
      this.$validator.reset();
      this.allocation = [];
      this.ofd = [];
      this.pod = [];
    },
    openPopUp(){
      this.showmodal = true;
    },
    closeModel(){
      this.showmodal = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ShipmentSummary/ShipmentSummary.component.js